import { render, staticRenderFns } from "./pro-card.vue?vue&type=template&id=27d51c86&scoped=true"
import script from "./pro-card.vue?vue&type=script&lang=js"
export * from "./pro-card.vue?vue&type=script&lang=js"
import style0 from "./pro-card.vue?vue&type=style&index=0&id=27d51c86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d51c86",
  null
  
)

export default component.exports